import axios from "axios";
import _ from "lodash";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  Button,
  Card,
  Dropdown,
  Header,
  Icon,
  Image,
  Menu,
  Search,
  Sidebar,
} from "semantic-ui-react";
import withMobile from "../withMobile";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import HomeIcon from "@mui/icons-material/Home";
import ListIcon from "@mui/icons-material/List";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import WorkIcon from "@mui/icons-material/Work";
import { styled } from "@mui/material/styles";
import Utils from "../util/Utils";
import Constants from "../util/Constants";
import MainNews from "./MainNews";
import CompanyPage from "../company/CompanyPage";
import "../css/home.css";
import Help from "../util/Help";
import LoadingSpinner from "../util/LoadingSpinner";
import ReleaseNotes from "../util/ReleaseNotes";
import CompareResults from "./CompareResults";
import EarningsCalendar from "./EarningsCalendar";
import ETFScreener from "./ETFScreener";
import HomeContainer from "./HomeContainer"; // This is different from PortfolioContainer
import IPOCalendar from "./IPOCalendar";
import MainHome from "./MainHome";
import { googleLogout, GoogleOAuthProvider } from "@react-oauth/google";
import { MobileProvider } from "../MobileContext";
import { createRoot } from "react-dom/client";
import MultiSearch from "./MultiSearch";
import PortfolioPerformance from "./PortfolioPerformance";
import ScreenerCombinedView from "./ScreenerCombinedView";
import StockScreener from "./StockScreener"; // Used by ScreenerContainer in PortfolioContainer
import ScreenerContainer from "./ScreenerContainer";
import SubmitFeature from "./SubmitFeature";
import WelcomePage from "./WelcomePage";
import PortfolioContainer from "./PortfolioContainer"; // The one with Tabs
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MuiButton from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WhatIfCalculator from "./WhatIfCalculator";
import SymbolSearch from "../components/SymbolSearch";
import { getMenuItems } from "../util/MenuItems";

var srchVal;

const initialSearchState = {
  isLoading: false,
  symbolResults: [],
  symbolValue: "",
  countryResults: [],
  countryValue: "",
};

const initialDisplayState = {
  sidebarVisible: false,
  loading: false,
  companyPage: null,
  showIndex: false,
  showFavorites: false,
  showScreener: false,
  showETFScreener: false,
  showStck: false,
  showPortfolioLeaderboard: false,
  showCmprStcks: false,
  showIPO: false,
  showEarningsCal: false,
  showHelp: false,
  showReleaseNotes: false,
  showSubmitFeature: false,
  showNews: false,
  showMyPortfolio: false,
  showCreateUserPortfolioForm: false,
  showWhatIfCalculator: false,
  /** When true, screener was opened from Portfolio Leaderboard — show back navigation */
  returnToPortfolioLeaderboard: false,
};

// Add this styled wrapper for fixed positioning
const FixedBottomNavigation = styled(BottomNavigation)({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
  backgroundColor: "#102138",
  "& .MuiBottomNavigationAction-label": {
    color: "white",
    "&.Mui-selected": {
      // Style for the selected label
      color: "green", // Replace with your desired color
    },
  },
  "& .MuiSvgIcon-root": {
    color: "white",
    "&.Mui-selected": {
      // Style for the selected icon
      color: "green", // Replace with your desired color
    },
  },
});

class Home extends Component {
  constructor(props) {
    super(props);
    console.log("Home constructor called:userEmail", this.props.userEmail);
    this.state = {
      ...initialSearchState,
      ...initialDisplayState,
      newUser: this.props.newUser,
      nodata: false,
      compareResults: null,
      isFavorite: false,
      companyPage: null,
      portfolio: null,
      stocksDropDownValues: [],
      cmpStckTickers: null,
      comparisionResult: null,
      symbolsList: [],
      gurusList: [],
      countriesList: [],
      portfolioImageUrl: null, // For generic screener portfolio image
      showIndex: true,
      isMobile: window.innerWidth < 767,

      //mobile navigation
      sidebarVisible: false,
      investmentIdeasOpen: false,
      helpOpen: false,
      toolsOpen: false,
      modelPortfoliosOpen: false,
      myListsOpen: false,
      indexStocksOpen: false,
      guruPortfoliosOpen: false,
      specialScreenersOpen: false,
      activeBottomTab: "home",

      // State for User's Portfolio (managed by Home.js now)
      userPortfolio: null, // Will store { id, userId, portfolioName, stocks, screenerData }
      userPortfolioLoading: false,
      userPortfolioError: null,
      portfolioExists: false, // For the user's own portfolio
      showCreateUserPortfolioForm: false,
      newUserPortfolioNameInput: "",
    };
    this.handleSidebarToggle = this.handleSidebarToggle.bind(this);
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.reloadHomePage = this.reloadHomePage.bind(this);
    this.loadSymbol = this.loadSymbol.bind(this);
    this.toggleInvestmentIdeas = this.toggleInvestmentIdeas.bind(this);
    this.toggleHelp = this.toggleHelp.bind(this);
    this.toggleTools = this.toggleTools.bind(this);
    this.toggleModelPortfolios = this.toggleModelPortfolios.bind(this);
    this.toggleIndexStocks = this.toggleIndexStocks.bind(this);
    this.toggleMyLists = this.toggleMyLists.bind(this);
    this.toggleGuruPortfolios = this.toggleGuruPortfolios.bind(this);
    this.toggleSpecialScreeners = this.toggleSpecialScreeners.bind(this);
    this.handleIdeas = this.handleIdeas.bind(this);
    this.handleCoatTailScreener = this.handleCoatTailScreener.bind(this);

    // New methods for managing user portfolio
    this.fetchUserPortfolio = this.fetchUserPortfolio.bind(this);
    this.handleCreateUserPortfolio = this.handleCreateUserPortfolio.bind(this);
    this.handleSaveStockInUserPortfolio =
      this.handleSaveStockInUserPortfolio.bind(this);
    this.handleDeleteStockInUserPortfolio =
      this.handleDeleteStockInUserPortfolio.bind(this);
  }

  getApiBaseUrlUserPortfolio = () => {
    // Ensure userEmail prop is available
    const userId = this.props.userEmail || "defaultUser"; // Fallback if userEmail is not passed
    return Utils.getServerURL() + `api/users/${userId}/portfolio`;
  };

  async componentDidMount() {
    let intializeURL = Constants.INITIALIZE_URL;
    try {
      const initializeResponse = await axios.get(intializeURL);
      this.setState({
        symbolsList: initializeResponse.data.symbolsList || [],
        gurusList: initializeResponse.data.gurusList || [],
        countriesList: initializeResponse.data.countriesList || [],
      });
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  }

  handleLogout = () => {
    googleLogout();
    const root = createRoot(document.getElementById("root"));
    root.render(
      <GoogleOAuthProvider clientId={Constants.GOOGLE_CLIENT_ID}>
        <MobileProvider>
          <MainHome />
        </MobileProvider>
      </GoogleOAuthProvider>
    );
  };

  resetNewUser = () => {
    this.setState({ newUser: false });
  };

  setShowHelp = () => {
    this.setState({
      ...initialDisplayState,
      showHelp: true,
    });
  };

  setShowReleaseNotes = () => {
    this.setState({
      ...initialDisplayState,
      showReleaseNotes: true,
    });
  };

  setShowSubmitFeature = () => {
    this.setState({
      ...initialDisplayState,
      showSubmitFeature: true,
    });
  };

  setShowIPO = () => {
    this.setState({
      ...initialDisplayState,
      showIPO: true,
    });
  };

  setShowScreener = (portfolio, portfolioImageUrl, navigationMeta = {}) => {
    console.log(
      "setting loading to false and showScreener to true::",
      portfolio
    );
    //console.log("setShowScreener portfolioImageUrl :", portfolioImageUrl);
    this.setState({
      ...initialDisplayState,
      portfolio: portfolio,
      portfolioImageUrl: portfolioImageUrl,
      showScreener: true,
      returnToPortfolioLeaderboard: Boolean(navigationMeta?.fromLeaderboard),
      // Not part of initialDisplayState; clear so screener is never blocked by My Portfolio fetch
      userPortfolioLoading: false,
    });
  };

  setShowETFScreener = (portfolio, portfolioImageUrl, navigationMeta = {}) => {
    //console.log("setShowETFScreener called", portfolio);
    this.setState({
      ...initialDisplayState,
      portfolio: portfolio,
      portfolioImageUrl: portfolioImageUrl,
      showETFScreener: true,
      returnToPortfolioLeaderboard: Boolean(navigationMeta?.fromLeaderboard),
      userPortfolioLoading: false,
    });
  };

  setShowFavorites = (portfolio, portfolioImageUrl) => {
    this.setState({
      ...initialDisplayState,
      portfolio: portfolio,
      portfolioImageUrl: portfolioImageUrl,
      showFavorites: true,
    });
  };

  compStcksSubmit = () => {
    ////console.log(this.cmpStckTickers);
    var cmpStcksArr = this.cmpStckTickers;
    var urlVal =
      Constants.COMPARE_TCKRS_URL +
      cmpStcksArr +
      "?userEmail=" +
      this.props.userEmail;

    axios({
      method: "get",
      responseType: "json",
      url: urlVal,
    })
      .then((response) => {
        var compareResults = response.data.compareResults;

        var cmprResultsContent = (
          <CompareResults
            stckLst={compareResults}
            userEmail={this.props.userEmail}
          />
        );

        this.setState({
          comparisionResult: cmprResultsContent,
          ...initialDisplayState,
          showCmprStcks: true,
        });
      })
      .catch(function (error) {
        //console.log("Home:compStcksSubmit app response Error:", error);
      });
  };

  compareStocks = () => {
    var stocksDropDownValuesArr = [];
    Object.values(this.state.symbolsList).forEach(function (compObj) {
      stocksDropDownValuesArr.push(compObj.title);
    });
    this.setState({
      ...initialDisplayState,
      showCmprStcks: true,

      cmpStckTickers: [],
      comparisionResult: "",
      stocksDropDownValues: stocksDropDownValuesArr,
    });
  };

  handleCmprStcks = (arr) => {
    this.cmpStckTickers = arr;
  };

  reloadHomePage = () => {
    this.setState({
      newUser: false,
      ...initialDisplayState,
      showIndex: true,
    });
  };

  // ** Function to handle Selected Ticker from search
  handleResultSelect = (e, { result }) => {
    ////console.log("In handleResultSet", result.title);
    this.setState({
      symbolValue: result.title,
    });
    srchVal = result.title;
    ////console.log("Search Symbol:", srchVal);
    this.onSubmit();
  };

  // ** Function to handle changed ticker
  handleSearchChange = (e, { value }) => {
    this.setState({ isLoading: true, symbolValue: value });

    setTimeout(() => {
      if (this.state.symbolValue.length < 1)
        return this.setState(...initialSearchState);

      const re = new RegExp("^" + _.escapeRegExp(this.state.symbolValue), "i");
      const isTMatch = (result) => re.test(result.title);
      const tR = _.filter(this.state.symbolsList, isTMatch);

      const reDesc = new RegExp(_.escapeRegExp(this.state.symbolValue), "i");
      const isDMatch = (result) => reDesc.test(result.description);
      const dR = _.filter(this.state.symbolsList, isDMatch);

      this.setState({
        isLoading: false,
        symbolResults: [...new Set(tR.concat(dR))],
      });
    }, 300);
  };

  // ** Function to handle changed country change
  handleCountryChange = (e, { value }) => {
    this.setState({ countryValue: value });

    setTimeout(() => {
      if (this.state.countryValue.length < 1)
        return this.setState(...initialSearchState);

      const re = new RegExp("^" + _.escapeRegExp(this.state.countryValue), "i");
      const isTMatch = (result) => re.test(result.title);
      const selectedCountry = _.filter(this.state.countriesList, isTMatch);

      this.setState({
        countryResults: [...new Set(selectedCountry)],
      });
    }, 300);
  };

  // ** Function to handle Selected Ticker from search
  handleCountryResultSelect = (e, { result }) => {
    //console.log("In handleResultSet", result);
    this.setState({
      countryValue: result.title,
    });
    ////console.log("Search Symbol:", srchVal);
    var urlVal =
      Constants.COUNTRY_URL +
      result.title +
      "?userEmail=" +
      this.props.userEmail;

    this.handleScreenerData(urlVal, this.setShowScreener);
  };

  // ** Function to handle Selected Ticker from search
  handleCountrySelect = (event) => {
    //console.log("In handleCountrySelect", event.target.innerText);

    var urlVal =
      Constants.COUNTRY_URL +
      event.target.innerText +
      "?userEmail=" +
      this.props.userEmail;

    let countryCode = event.target.getAttribute("name");

    //console.log(
    //  "handleCountrySelect countryCode:",
    //event.target.getAttribute("name")
    //);

    const countryImageUrl =
      "https://www.countryflags.io/" + countryCode + "/shiny/64.png";

    //console.log("handleCountrySelect:", event.target.getAttribute("name"));

    //console.log("handleCountrySelect:", countryImageUrl);

    this.handleScreenerData(urlVal, this.setShowScreener, countryImageUrl);
  };

  // ** Fuction for button on click
  handleIdeas = (event, data) => {
    var urlVal =
      Constants.SCREENER_URL +
      event.target.innerText +
      "?userEmail=" +
      this.props.userEmail;

    this.handleScreenerData(urlVal, this.setShowScreener);
  };

  handleIndex = (name) => {
    let url =
      Constants.COATTAIL_URL + name + "?userEmail=" + this.props.userEmail;

    this.handleScreenerData(url, this.setShowScreener);
  };

  handleCoatTailScreener = (event, data) => {
    if (!data || !data.value) return;

    const guruName = encodeURIComponent(data.value);
    const url =
      Constants.COATTAIL_URL +
      guruName +
      "?userEmail=" +
      encodeURIComponent(this.props.userEmail || "");

    const guru = this.state.gurusList?.find(
      (g) => g.guru === data.value || g.name === data.value
    );
    const portfolioImageUrl = guru?.image
      ? `${process.env.PUBLIC_URL}/images/screener-images/${guru.image}.jpg`
      : undefined;
    const portfolioAbout = guru?.about;

    this.handleScreenerData(
      url,
      this.setShowScreener,
      portfolioImageUrl,
      portfolioAbout
    );
  };

  handleRecentIPOs = (event) => {
    let url = Constants.RECENT_IPOS_URL + "?userEmail=" + this.props.userEmail;

    this.handleScreenerData(url, this.setShowScreener);
  };

  handleSectorScreener = (event) => {
    var urlVal =
      Constants.SECTOR_SCREENER_URL +
      event.target.innerText +
      "?userEmail=" +
      this.props.userEmail;

    this.handleScreenerData(urlVal, this.setShowScreener);
  };

  handleSectorETFScreener = (event, data) => {

    let url =
      Constants.COATTAIL_URL +
      "Index and Sector Tracker" +
      "?userEmail=" +
      this.props.userEmail;

    console.log("coming here", url);

    this.handleScreenerData(url, this.setShowETFScreener);
  };

  handleIndustryScreener = (event) => {
    //console.log("Click happened" + event.target.value);
    var urlVal =
      Constants.INDUSTRY_SCREENER_URL +
      event.target.innerText +
      "?userEmail=" +
      this.props.userEmail;

    this.handleScreenerData(urlVal, this.setShowScreener);
  };

  handleFavorites = () => {
    var urlVal =
      Constants.SCREENER_URL + "Favorites?userEmail=" + this.props.userEmail;

    // Use setShowScreener instead of setShowFavorites to follow main screener path
    this.handleScreenerData(urlVal, this.setShowScreener);
  };

  handleFullScreener = () => {
    //console.log("Click happened");
    var urlVal =
      Constants.SCREENER_URL + "all?userEmail=" + this.props.userEmail;

    this.handleScreenerData(urlVal, this.setShowScreener);
  };

  handleETFScreener = () => {
    //console.log("Click happened");
    var urlVal =
      Constants.SCREENER_URL + "etfall?userEmail=" + this.props.userEmail;

    this.handleScreenerData(urlVal, this.setShowETFScreener);
  };

  handleEarningsCalendar = (event) => {
    this.setState({
      ...initialDisplayState,
      showEarningsCal: true,
    });
  };

  handleNews = (event) => {
    this.setState({
      ...initialDisplayState,
      showNews: true,
    });
  };

  handlePortfolioPerformance = (event) => {
    this.setState({
      ...initialDisplayState,
      showPortfolioLeaderboard: true,
    });
  };

  /**
   * Open a portfolio from the leaderboard grid.
   * Model-portfolio / guru / SS / watch-list rows use coattail (same as Model Portfolios menu);
   * other rows use the stock screener API (same as Investment Ideas).
   * @param {{ name?: string, type?: string }} row — API row with portfolio display name and optional category
   */
  openPortfolioFromLeaderboard = (row) => {
    if (!row?.name || !this.props.userEmail) {
      return;
    }
    const typeStr = (row.type || "").toString().toLowerCase();
    const gurus = this.state.gurusList || [];
    const matchedGuru = gurus.find(
      (g) => g.guru === row.name || g.name === row.name
    );

    const staticCoattailNames = new Set([
      "FAANG",
      "Magnificent 7",
      "TAMANA",
      "Index and Sector Tracker",
    ]);

    const coattailByType =
      typeStr.includes("investment guru") ||
      typeStr.includes("watch list") ||
      typeStr.includes("ss list") ||
      typeStr.includes("ss picks") ||
      typeStr.includes("model portfolio") ||
      typeStr.includes("guru") ||
      typeStr.includes("social media");

    const useCoattail =
      !!matchedGuru || staticCoattailNames.has(row.name) || coattailByType;

    const useEtfScreener =
      typeStr.includes("etf") ||
      typeStr.includes("fund") ||
      row.name === "etfall" ||
      row.name === "Index and Sector Tracker";

    let url;
    let portfolioImageUrl;
    let portfolioAbout;

    if (useCoattail) {
      const coattailKey = matchedGuru?.guru || row.name;
      url =
        Constants.COATTAIL_URL +
        encodeURIComponent(coattailKey) +
        "?userEmail=" +
        encodeURIComponent(this.props.userEmail);
      if (matchedGuru?.image) {
        portfolioImageUrl = `${process.env.PUBLIC_URL}/images/screener-images/${matchedGuru.image}.jpg`;
      }
      portfolioAbout = matchedGuru?.about;
    } else {
      url =
        Constants.SCREENER_URL +
        encodeURIComponent(row.name) +
        "?userEmail=" +
        encodeURIComponent(this.props.userEmail);
    }

    const displayFn = useEtfScreener ? this.setShowETFScreener : this.setShowScreener;
    this.handleScreenerData(url, displayFn, portfolioImageUrl, portfolioAbout, {
      fromLeaderboard: true,
    });
  };

  handleBackToPortfolioLeaderboard = () => {
    this.setState({
      ...initialDisplayState,
      showPortfolioLeaderboard: true,
      portfolio: null,
      portfolioImageUrl: null,
      nodata: false,
      loading: false,
    });
  };

  async handleScreenerData(
    url,
    displayBlockFn,
    portfolioImageUrl,
    portfolioAbout,
    navigationMeta = {}
  ) {
    console.log("setting loading to true::", url);

    this.setState({
      loading: true,
    });

    try {
      const [response] = await Promise.all([axios.get(url)]);

      if (response && response.data && response.data.portfolio) {
        let portfolio = response.data.portfolio;
        if (portfolioAbout) {
          portfolio = { ...portfolio, about: portfolioAbout };
        }
        displayBlockFn(portfolio, portfolioImageUrl, navigationMeta);
      } else {
        console.error("Invalid response structure:", response);
        this.setState({
          loading: false,
          nodata: true,
        });
      }
    } catch (error) {
      console.error("Error fetching screener data:", error);
      console.error("Failed URL:", url);
      this.setState({
        loading: false,
        nodata: true,
      });
      // Optionally show an error message to the user
      if (error.response) {
        console.error("Error status:", error.response.status);
        console.error("Error data:", error.response.data);
      }
    }
  }

  /**
   * Unified navigation handler for menu items
   * This method interprets navigation metadata and executes the appropriate navigation
   * @param {Object} menuItem - Menu item with navigation metadata
   */
  handleMenuNavigation = (menuItem) => {
    const { navigationType, urlTemplate, displayState, stateUpdate, specialHandler, searchValue, countryCode } = menuItem;
    
    // Close sidebar if open (mobile)
    if (this.state.sidebarVisible) {
      this.handleSidebarToggle();
    }
    
    // Special handlers that need custom logic
    if (specialHandler === 'reloadHomePage') {
      return this.reloadHomePage();
    }
    if (specialHandler === 'myPortfolio') {
      return this.handleMenuItemClick(null, { name: 'myPortfolio' });
    }
    if (specialHandler === 'compareStocks') {
      return this.compareStocks(); // Sets showCmprStcks state
    }
    
    // State-only navigation (IPO Calendar, News, Earnings Calendar, Compare Stocks, etc.)
    if (navigationType === 'state_only' && stateUpdate) {
      return this.setState({
        ...initialDisplayState,
        ...stateUpdate
      });
    }
    
    // URL-based navigation (screeners, ETFs, favorites)
    if (urlTemplate && displayState) {
      // Validate userEmail before constructing URL
      // Skip navigation if userEmail is missing - this can happen in dev mode
      if (!this.props.userEmail) {
        console.warn("userEmail is required for URL-based navigation:", menuItem.title);
        console.warn("Menu item:", menuItem);
        console.warn("Skipping navigation - this is normal in development mode without authentication");
        return;
      }
      
      // Use searchValue if provided (for items like sp500_constituent), otherwise use title
      const nameToUse = searchValue || menuItem.title;
      // Only replace {name} if it exists in the template, otherwise use the template as-is
      let url = urlTemplate.includes('{name}') 
        ? urlTemplate.replace('{name}', encodeURIComponent(nameToUse))
        : urlTemplate;
      
      // Replace {userEmail} with the actual email (already validated above)
      url = url.replace('{userEmail}', encodeURIComponent(this.props.userEmail));
      
      console.log("Constructed URL:", url);
      console.log("Menu item:", menuItem.title, "userEmail:", this.props.userEmail);
      
      // Use setShowScreener for both 'screener' and 'favorites' to follow main screener path
      const displayFn = displayState === 'screener' || displayState === 'favorites' ? this.setShowScreener
                      : displayState === 'etf_screener' ? this.setShowETFScreener
                      : null;
      
      if (displayFn) {
        // Handle country select specially (needs country code for image URL)
        if (menuItem.category === 'Screeners > Countries' && countryCode) {
          const countryImageUrl = `https://www.countryflags.io/${countryCode}/shiny/64.png`;
          return this.handleScreenerData(url, displayFn, countryImageUrl);
        }
        return this.handleScreenerData(url, displayFn);
      } else {
        console.error("No display function found for displayState:", displayState);
      }
    }
  };

  // ** Function to tab selection
  handleItemClick = (e, { name }) => {
    //console.log("Home:handleItemClick:", name);
    this.setState({
      activeItem: name,
    });
  };

  onSubmit = () => {
    //reset the page with empty
    this.setState({
      nodata: false,
      ...initialDisplayState,
      showStck: true,
    });

    if (srchVal === "") {
      alert("Please enter a stock Symbol !!");
      return false;
    }

    this.setState({
      loading: true,
    });

    var companyPage = this.state.loading ? (
      <LoadingSpinner />
    ) : (
      <CompanyPage userEmail={this.props.userEmail} symbol={srchVal} />
    );
    this.setState({
      loading: false,
      nodata: false,
      companyPage: companyPage,
    });
  };

  ag_grid_cell_click = (event) => {
    var col_heading = event.colDef.field;
    if (col_heading === "symbol") {
      //alert(event.value);
      this.loadSymbol(event.value);
    }
  };

  loadSymbol = (symbol) => {
    this.setState({
      symbolValue: symbol,
    });
    srchVal = symbol;
    this.onSubmit();
  };

  //-------------------

  toggleInvestmentIdeas = () =>
    this.setState({ investmentIdeasOpen: !this.state.investmentIdeasOpen });
  toggleHelp = () => this.setState({ helpOpen: !this.state.helpOpen });
  toggleTools = () => this.setState({ toolsOpen: !this.state.toolsOpen });
  toggleModelPortfolios = () =>
    this.setState({ modelPortfoliosOpen: !this.state.modelPortfoliosOpen });
  toggleIndexStocks = () =>
    this.setState({ indexStocksOpen: !this.state.indexStocksOpen });
  toggleMyLists = () => this.setState({ myListsOpen: !this.state.myListsOpen });
  toggleGuruPortfolios = () =>
    this.setState({ guruPortfoliosOpen: !this.state.guruPortfoliosOpen });
  toggleSpecialScreeners = () =>
    this.setState({ specialScreenersOpen: !this.state.specialScreenersOpen });
  handleSidebarToggle = () =>
    this.setState({ sidebarVisible: !this.state.sidebarVisible });

  handleMenuItemClick(e, { name }) {
    this.setState(
      { activeItem: name, ...initialDisplayState, sidebarVisible: false },
      () => {
        switch (name) {
          case "myPortfolio":
            this.setState({ showMyPortfolio: true });
            this.fetchUserPortfolio(); // Fetch data when "My Portfolio" is clicked
            break;
          case "Favorites":
            this.handleFavorites();
            break;
          case "signout":
            this.handleLogout();
            break;
          case "siteHelp":
            this.setState({ showHelp: true });
            break;
          case "releaseNotes":
            this.setState({ showReleaseNotes: true });
            break;
          case "submitFeature":
            this.setState({ showSubmitFeature: true });
            break;
          default:
            break;
        }
      }
    );
  }

  handleBottomNavigationChange = (event, newValue) => {
    this.setState({ activeBottomTab: newValue });

    // Handle navigation logic here
    switch (newValue) {
      case "latestNews":
        this.handleNews();
        break;
      case "home":
        console.log("Navigate to Home");
        this.reloadHomePage();
        break;
      case "watchList":
        console.log("Navigate to WatchList");
        this.handleFavorites();
        break;
      default:
        break;
    }
  };

  fetchUserPortfolio = async () => {
    console.log("fetchUserPortfolio called");
    if (!this.props.userEmail) {
      console.error("User email is not available to fetch portfolio.");
      this.setState({
        userPortfolioError: "User not identified.",
        userPortfolioLoading: false,
        portfolioExists: false,
        showCreateUserPortfolioForm: false,
      });
      return;
    }
    this.setState({ userPortfolioLoading: true, userPortfolioError: null });
    try {
      console.log("Making API call to:", this.getApiBaseUrlUserPortfolio());
      const response = await axios.get(this.getApiBaseUrlUserPortfolio());
      console.log("API response:", response.data);
      if (response.data) {
        this.setState(
          {
            userPortfolio: response.data,
            portfolioExists: true,
            showCreateUserPortfolioForm: false,
            userPortfolioLoading: false,
          },
          () => {
            console.log("State after setting portfolio data:", this.state);
          }
        );
      }
    } catch (error) {
      console.error("Error in fetchUserPortfolio:", error);
      if (error.response && error.response.status === 404) {
        this.setState({
          portfolioExists: false,
          showCreateUserPortfolioForm: true,
          userPortfolio: null,
          userPortfolioLoading: false,
        });
      } else {
        console.error("Failed to fetch user portfolio:", error);
        this.setState({
          userPortfolioError:
            error.message || "Could not load your portfolio data.",
          portfolioExists: false,
          userPortfolioLoading: false,
          // showCreateUserPortfolioForm: true, // Optionally show create form on other errors too
        });
      }
    }
  };

  handleCreateUserPortfolio = async (e) => {
    e.preventDefault();
    if (!this.state.newUserPortfolioNameInput.trim()) {
      alert("Portfolio name cannot be empty.");
      return;
    }
    if (!this.props.userEmail) {
      alert("User email is required to create a portfolio.");
      return;
    }
    this.setState({ userPortfolioLoading: true, userPortfolioError: null });
    try {
      await axios.post(this.getApiBaseUrlUserPortfolio(), {
        portfolioName: this.state.newUserPortfolioNameInput,
      });
      this.setState({ newUserPortfolioNameInput: "" });
      await this.fetchUserPortfolio(); // Re-fetch to get the new portfolio state
    } catch (err) {
      console.error("Failed to create portfolio:", err);
      this.setState({
        userPortfolioError:
          err.response?.data?.message ||
          err.message ||
          "Could not create portfolio.",
        userPortfolioLoading: false,
      });
    }
  };

  handleSaveStockInUserPortfolio = async (
    stockDataPayload,
    isNew,
    stockIdToUpdate
  ) => {
    if (!this.props.userEmail) {
      this.setState({
        userPortfolioError: "User not identified for saving stock.",
      });
      return false;
    }
    this.setState({ userPortfolioLoading: true, userPortfolioError: null });
    const url = isNew
      ? `${this.getApiBaseUrlUserPortfolio()}/stocks`
      : `${this.getApiBaseUrlUserPortfolio()}/stocks/${stockIdToUpdate}`;
    const method = isNew ? "post" : "put";

    try {
      await axios({ method, url, data: stockDataPayload });
      await this.fetchUserPortfolio(); // Re-fetch on success
      return true;
    } catch (e) {
      console.error(`Failed to ${isNew ? "add" : "update"} stock:`, e);
      this.setState({
        userPortfolioError:
          e.response?.data?.message ||
          e.message ||
          `Failed to ${isNew ? "add" : "update"} stock.`,
        userPortfolioLoading: false,
      });
      return false;
    }
  };

  handleDeleteStockInUserPortfolio = async (stockIdToDelete) => {
    if (!this.props.userEmail) {
      this.setState({
        userPortfolioError: "User not identified for deleting stock.",
      });
      return false;
    }
    this.setState({ userPortfolioLoading: true, userPortfolioError: null });
    try {
      await axios.delete(
        `${this.getApiBaseUrlUserPortfolio()}/stocks/${stockIdToDelete}`
      );
      await this.fetchUserPortfolio(); // Re-fetch on success
      return true;
    } catch (e) {
      console.error("Failed to delete stock:", e);
      this.setState({
        userPortfolioError:
          e.response?.data?.message || e.message || "Failed to delete stock.",
        userPortfolioLoading: false,
      });
      return false;
    }
  };

  handleWhatIfCalculator = () => {
    this.setState({
      ...initialDisplayState,
      showWhatIfCalculator: true,
      sidebarVisible: false,
    });
  };

  handleSymbolSelect = (symbol) => {
    this.setState({ symbolValue: symbol });
    srchVal = symbol;
    this.onSubmit();
  };

  renderBackToLeaderboardBar() {
    if (!this.state.returnToPortfolioLeaderboard) {
      return null;
    }
    return (
      <Box
        sx={{
          width: "100%",
          px: { xs: 1, sm: 2 },
          py: 0.75,
          display: "flex",
          alignItems: "center",
          bgcolor: "action.hover",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <MuiButton
          variant="text"
          size="small"
          startIcon={<ArrowBackIcon fontSize="small" />}
          onClick={this.handleBackToPortfolioLeaderboard}
          sx={{ fontWeight: 600, textTransform: "none" }}
        >
          Back to Portfolio Leaderboard
        </MuiButton>
      </Box>
    );
  }

  render() {
    const {
      showStck,
      companyPage,
      activeItem,
      loading,
      isLoading,
      symbolValue,
      symbolResults,
      showHelp,
      showFavorites,
      showReleaseNotes,
      showIndex,
      showScreener,
      showETFScreener,
      showPortfolioLeaderboard,
      showCmprStcks,
      showSubmitFeature,
      showIPO,
      showEarningsCal,
      showNews,
      stocksDropDownValues,
      comparisionResult,
      portfolioImageUrl,
      isMobile,
      sidebarVisible,
      investmentIdeasOpen,
      toolsOpen,
      helpOpen,
      modelPortfoliosOpen,
      myListsOpen,
      indexStocksOpen,
      guruPortfoliosOpen,
      specialScreenersOpen,
      activeBottomTab,
      showMyPortfolio,
      showWhatIfCalculator,
      userPortfolio,
      userPortfolioLoading,
      userPortfolioError,
      portfolioExists,
      showCreateUserPortfolioForm,
      newUserPortfolioNameInput,
      portfolio,
    } = this.state;

    let isFullScreener = portfolio
      ? portfolio.name === "all"
        ? true
        : false
      : false;

    const signoutButton = (
      <Button
        basic
        inverted
        onClick={this.handleLogout}
        title="Sign out"
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Icon name="log out" />
      </Button>
    );

    const menuIcon = sidebarVisible ? "close" : "bars";

    let mainContent = null;

    if (showStck) {
      mainContent = (
        <div id="companypage">{loading ? <LoadingSpinner /> : companyPage}</div>
      );
    } else if (showScreener) {
      mainContent = (
        <div
          style={{ width: "100%", margin: 0, padding: 0, overflow: "hidden" }}
        >
          {this.renderBackToLeaderboardBar()}
          {!isFullScreener ? (
            <ScreenerContainer
              userEmail={this.props.userEmail}
              portfolio={portfolio}
              screenerTitle={portfolio?.name}
              agGridFn={this.ag_grid_cell_click}
              snapShotFn={this.loadSymbol}
              portfolioImageUrl={portfolioImageUrl}
            />
          ) : (
            <StockScreener
              userEmail={this.props.userEmail}
              portfolio={portfolio}
              portfolioImageUrl={portfolioImageUrl}
            />
          )}
        </div>
      );
    } else if (showETFScreener) {
      mainContent = (
        <div
          style={{
            width: "auto",
            marginTop: 0,
          }}
        >
          {this.renderBackToLeaderboardBar()}
          {loading ? (
            <LoadingSpinner />
          ) : (
            <ETFScreener
              userEmail={this.props.userEmail}
              portfolio={portfolio}
              agGridFn={this.ag_grid_cell_click}
            />
          )}
        </div>
      );
    } else if (showPortfolioLeaderboard) {
      mainContent = (
        <PortfolioPerformance onOpenPortfolio={this.openPortfolioFromLeaderboard} />
      );
    } else if (showSubmitFeature) {
      mainContent = (
        <div
          style={{
            height: "84vh",
            display: showSubmitFeature ? "block" : "none",
          }}
        >
          <SubmitFeature
            name={this.props.name}
            email={this.props.userEmail}
            contactURL={Constants.FEATURE_REQUEST_URL}
            header="Please submit a feature request or feedback"
          />
        </div>
      );
    } else if (showHelp) {
      mainContent = (
        <div
          style={{
            marginTop: "1rem",
            maxWidth: "900px",
            margin: "1rem auto 0",
            padding: "0 1rem",
            display: showHelp ? "block" : "none",
          }}
        >
          <Help />
        </div>
      );
    } else if (showReleaseNotes) {
      mainContent = (
        <div
          style={{
            maxWidth: "900px",
            margin: "1rem auto",
            padding: "0 1rem",
            minHeight: "80vh",
            display: showReleaseNotes ? "block" : "none",
          }}
        >
          <ReleaseNotes />
        </div>
      );
    } else if (showFavorites) {
      mainContent = (
        <div
          style={{
            maxWidth: "960px",
            margin: "1rem auto",
            padding: "0 1rem",
            display: showFavorites ? "block" : "none",
          }}
        >
          <ScreenerCombinedView
            stockReports={portfolio ? portfolio.stockReports : null}
            displayAll={true}
          />
        </div>
      );
    } else if (showIndex) {
      mainContent = (
        <div
          id="home-container"
          style={{
            justifyContent: "center",
            display: showIndex ? "block" : "none",
          }}
        >
          {!this.state.newUser ? (
            <HomeContainer
              onClickIndexFunction={this.handleIndex}
              onClickSymbolFunction={this.loadSymbol}
            />
          ) : (
            <WelcomePage userName={this.props.userName} />
          )}
        </div>
      );
    } else if (showIPO) {
      mainContent = (
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "1%",
            display: showIPO ? "block" : "none",
          }}
        >
          <IPOCalendar />
        </div>
      );
    } else if (showEarningsCal) {
      mainContent = (
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "1%",
            display: showEarningsCal ? "block" : "none",
          }}
        >
          <EarningsCalendar userEmail={this.props.userEmail} />
        </div>
      );
    } else if (showNews) {
      mainContent = (
        <div
          style={{
            minHeight: "600vh",
            height: "74vh",
            marginTop: "2%",
            display: showNews ? "block" : "none",
          }}
        >
          <MainNews />
        </div>
      );
    } else if (showCmprStcks) {
      mainContent = (
        <div
          style={{
            maxWidth: "960px",
            margin: "0.75rem auto 1rem",
            padding: "0 1rem",
            display: showCmprStcks ? "block" : "none",
          }}
        >
          <div
            style={{
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              align="center"
              sx={{
                color: "primary.dark",
                fontWeight: 600,
                mb: 2,
                mt: 0.5,
                fontSize: { xs: "1.5rem", md: "1.75rem" },
                letterSpacing: "-0.02em",
              }}
            >
              Compare Stocks
            </Typography>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <MultiSearch
              searchable={true}
              showTags={true}
              multiSelect={true}
              width={this.props.isMobile ? "100%" : "570px"}
              onSelect={this.handleCmprStcks}
              options={stocksDropDownValues}
              searchPlaceholder={"Select Max 4 Symbols to compare"}
              primaryColor={"#FFFFFF"}
            />
            <div>
              <br />
              <Button
                size="large"
                className="ui blue button"
                onClick={this.compStcksSubmit}
              >
                Compare
              </Button>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1%",
              marginBottom: "1%",
            }}
          >
            {comparisionResult}
          </div>
        </div>
      );
    } else if (showMyPortfolio) {
      mainContent = (
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "1%",
            display: showMyPortfolio ? "block" : "none",
          }}
        >
          <PortfolioContainer
            userEmail={this.props.userEmail}
            userPortfolio={userPortfolio}
            portfolioExists={portfolioExists}
            showCreateUserPortfolioForm={showCreateUserPortfolioForm}
            newUserPortfolioNameInput={newUserPortfolioNameInput}
            onNewPortfolioNameInputChange={(e) =>
              this.setState({ newUserPortfolioNameInput: e.target.value })
            }
            onCreateUserPortfolio={this.handleCreateUserPortfolio}
            isLoading={userPortfolioLoading}
            error={userPortfolioError}
            onSaveStock={this.handleSaveStockInUserPortfolio}
            onDeleteStock={this.handleDeleteStockInUserPortfolio}
            onRefreshPortfolio={this.fetchUserPortfolio}
            portfolioImageUrlFromHome={portfolioImageUrl}
            snapShotFnFromHome={this.loadSymbol}
          />
        </div>
      );
    } else if (showWhatIfCalculator) {
      mainContent = (
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "1%",
            display: showWhatIfCalculator ? "block" : "none",
          }}
        >
          <WhatIfCalculator />
        </div>
      );
    }

    return (
      <>
        {!isMobile ? (
          <div
            style={{
              width: "100%",
              top: "0",
              height: "60px",
              position: "relative",
              zIndex: 1,
              backgroundColor: "#102138",
              verticalAlign: "middle",
              marginBottom: 0,
            }}
          >
            <Menu
              compact
              fluid
              inverted
              borderless
              unstacakble
              style={{
                backgroundColor: "#102138",
              }}
            >
              <Menu.Item>
                <div
                  style={{
                    width: 140,
                    height: 36,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#102138",
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/simply.png`}
                    alt="SimplyStock"
                    onClick={this.reloadHomePage}
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                                    borderRadius: "8px",
                border: "2px solid #d4a017",

                    }}
                  />
                </div>{" "}
              </Menu.Item>

              <Menu.Item name="search" active={activeItem === "search"}>
                <SymbolSearch
                  onSymbolSelect={this.handleSymbolSelect}
                  onMenuSelect={this.handleMenuNavigation}
                  userEmail={this.props.userEmail}
                  dynamicItems={{
                    gurusList: this.state.gurusList || [],
                    countriesList: this.state.countriesList || [],
                  }}
                  initialValue={this.state.symbolValue}
                  fluid
                />
              </Menu.Item>
              <Menu.Item fitted>
                <Dropdown item text="Investment Ideas">
                  <Dropdown.Menu>
                    <Dropdown item text="SS Picks">
                      <Dropdown.Menu>
                        {this.state.gurusList &&
                          this.state.gurusList
                            .filter((item) => item.type === "SS List")
                            .map((item) => (
                              <Dropdown.Item
                                key={item.guru}
                                value={item.guru}
                                onClick={this.handleCoatTailScreener}
                              >
                                {item.guru}
                              </Dropdown.Item>
                            ))}
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown.Item
                      value="Buy Rated Stocks dipped Today"
                      onClick={this.handleIdeas}
                    >
                      Buy Rated Stocks dipped Today
                    </Dropdown.Item>
                    <Dropdown.Item value="Bestofall" onClick={this.handleIdeas}>
                      Best of All
                    </Dropdown.Item>
                    <Dropdown.Item value="top50" onClick={this.handleIdeas}>
                      Top 50 Value Stocks
                    </Dropdown.Item>
                    <Dropdown.Item value="largeCap" onClick={this.handleIdeas}>
                      Large Cap Growth
                    </Dropdown.Item>
                    <Dropdown.Item value="smallMid" onClick={this.handleIdeas}>
                      Great Small &amp; Mid size Companies
                    </Dropdown.Item>
                    <Dropdown.Item value="gems20" onClick={this.handleIdeas}>
                      Gems under $20
                    </Dropdown.Item>
                    <Dropdown.Item value="dividend" onClick={this.handleIdeas}>
                      Good Dividend Stocks
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="speculative"
                      onClick={this.handleIdeas}
                    >
                      Speculative Growth Stocks
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="highPFStocks"
                      onClick={this.handleIdeas}
                    >
                      High Performing Stocks
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="highProfitMargin"
                      onClick={this.handleIdeas}
                    >
                      High Profit Margin Stocks
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
              <Menu.Item fitted>
                <Dropdown item text="Model Portfolios">
                  <Dropdown.Menu>
                    <Dropdown item text="Gurus" simple direction="right">
                      <Dropdown.Menu>
                        {this.state.gurusList &&
                          this.state.gurusList
                            .filter((item) => item.type === "Investment Guru")
                            .map((item) => (
                              <Dropdown.Item
                                key={item.guru}
                                value={item.guru}
                                onClick={this.handleCoatTailScreener}
                              >
                                {item.guru}
                              </Dropdown.Item>
                            ))}
                      </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown item text="Social Media">
                      <Dropdown.Menu>
                        {this.state.gurusList &&
                          this.state.gurusList
                            .filter((item) => item.type === "Watch List")
                            .map((item) => (
                              <Dropdown.Item
                                key={item.guru}
                                value={item.guru}
                                onClick={this.handleCoatTailScreener}
                              >
                                {item.guru}
                              </Dropdown.Item>
                            ))}
                      </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown.Item
                      value="FAANG"
                      onClick={this.handleCoatTailScreener}
                    >
                      FAANG
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="Magnificent 7"
                      onClick={this.handleCoatTailScreener}
                    >
                      Magnificent 7
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="TAMANA"
                      onClick={this.handleCoatTailScreener}
                    >
                      TAMANA
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
              <Menu.Item fitted>
                <Dropdown item text="Screeners">
                  <Dropdown.Menu>
                    <Dropdown item text="Sectors">
                      <Dropdown.Menu>
                        <Dropdown.Item
                          value="Technology"
                          onClick={this.handleSectorScreener}
                        >
                          Technology
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Basic Materials"
                          onClick={this.handleSectorScreener}
                        >
                          Basic Materials
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Communication Services"
                          onClick={this.handleSectorScreener}
                        >
                          Communication Services
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Consumer Cyclical"
                          onClick={this.handleSectorScreener}
                        >
                          Consumer Cyclical
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Consumer Defensive"
                          onClick={this.handleSectorScreener}
                        >
                          Consumer Defensive
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Energy"
                          onClick={this.handleSectorScreener}
                        >
                          Energy
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Financial"
                          onClick={this.handleSectorScreener}
                        >
                          Financial
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Healthcare"
                          onClick={this.handleSectorScreener}
                        >
                          Healthcare
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Industrials"
                          onClick={this.handleSectorScreener}
                        >
                          Industrials
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Real Estate"
                          onClick={this.handleSectorScreener}
                        >
                          Real Estate
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item text="Industries">
                      <Dropdown.Menu>
                        <Dropdown.Item
                          value="Residential Construction"
                          onClick={this.handleIndustryScreener}
                        >
                          Residential Construction
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Restaurants"
                          onClick={this.handleIndustryScreener}
                        >
                          Restaurants
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Lodging"
                          onClick={this.handleIndustryScreener}
                        >
                          Lodging
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Airlines"
                          onClick={this.handleIndustryScreener}
                        >
                          Airlines
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Resorts &amp; Casinos"
                          onClick={this.handleIndustryScreener}
                        >
                          Resorts &amp; Casinos
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Travel &amp; Leisure"
                          onClick={this.handleIndustryScreener}
                        >
                          Travel &amp; Leisure
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Travel Services"
                          onClick={this.handleIndustryScreener}
                        >
                          Travel Services
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Grocery Stores"
                          onClick={this.handleIndustryScreener}
                        >
                          Grocery Stores
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Discount Stores"
                          onClick={this.handleIndustryScreener}
                        >
                          Discount Stores
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Semiconductor"
                          onClick={this.handleIndustryScreener}
                        >
                          Semiconductor
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Pharma Companies"
                          onClick={this.handleCoatTailScreener}
                        >
                          Pharma Companies
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Shell Companies"
                          onClick={this.handleSectorScreener}
                        >
                          Shell Companies
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Cannabis"
                          onClick={this.handleCoatTailScreener}
                        >
                          Cannabis
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Space Exploration"
                          onClick={this.handleCoatTailScreener}
                        >
                          Space Exploration
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown item text="Country" scrolling>
                      <Dropdown.Menu>
                        {this.state.countriesList &&
                          this.state.countriesList.map((item) => (
                            <Dropdown.Item
                              key={item.code}
                              value={item.code}
                              onClick={this.handleCountrySelect}
                            >
                              {item.value}
                            </Dropdown.Item>
                          ))}
                      </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown item text="Ev Related">
                      <Dropdown.Menu>
                        <Dropdown.Item
                          value="Electric Vehicles"
                          onClick={this.handleCoatTailScreener}
                        >
                          Electric Vehicles
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Battery-Charging"
                          onClick={this.handleCoatTailScreener}
                        >
                          Battery-Charging
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Natural Resources"
                          onClick={this.handleCoatTailScreener}
                        >
                          Natural Resources
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="LIDAR"
                          onClick={this.handleCoatTailScreener}
                        >
                          LIDAR
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="EV Resources"
                          onClick={this.handleCoatTailScreener}
                        >
                          EV Resources
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item text="Clean Energy">
                      <Dropdown.Menu>
                        <Dropdown.Item
                          value="Solar"
                          onClick={this.handleCoatTailScreener}
                        >
                          Solar
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Fuel Cell"
                          onClick={this.handleCoatTailScreener}
                        >
                          Fuel Cell
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item text="Speciality Tech">
                      <Dropdown.Menu>
                        <Dropdown.Item
                          value="Quantum Pure-play"
                          onClick={this.handleCoatTailScreener}
                        >
                          Quantum Pure-play
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Data Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          Data Tech
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Internet Retail"
                          onClick={this.handleCoatTailScreener}
                        >
                          Internet Retail
                        </Dropdown.Item>

                        <Dropdown.Item
                          value="Health Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          Health Tech
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Real Estate Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          Real Estate Tech
                        </Dropdown.Item>

                        <Dropdown.Item
                          value="Fin Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          Fin Tech
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Bio Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          Bio Tech
                        </Dropdown.Item>

                        <Dropdown.Item
                          value="Cloud Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          Cloud Tech
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="5g Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          5g Tech
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="AI Robotics Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          AI Robotics Tech
                        </Dropdown.Item>
                        <Dropdown.Item
                          value="Advertisement Tech"
                          onClick={this.handleCoatTailScreener}
                        >
                          Advertisement Tech
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown.Item
                      value="Led by Indian CEOs"
                      onClick={this.handleCoatTailScreener}
                    >
                      Led by Indian CEOs
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="GLP-1 Drug Companies"
                      onClick={this.handleCoatTailScreener}
                    >
                      GLP-1 Drug Companies
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="IPOs in last one year"
                      onClick={this.handleRecentIPOs}
                    >
                      IPOs in last one year
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
              <Menu.Item fitted>
                <Dropdown item text="My Lists">
                  <Dropdown.Menu>
                    <Dropdown.Item value="watchList" onClick={this.handleIdeas}>
                      Favorites
                    </Dropdown.Item>
                    <Dropdown.Item
                      name="myPortfolio"
                      active={activeItem === "myPortfolio"}
                      onClick={(e) => {
                        this.handleMenuItemClick(e, { name: "myPortfolio" });
                        this.handleSidebarToggle();
                      }}
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Icon name="briefcase" />
                      My Portfolio
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
              <Menu.Item fitted>
                <Dropdown item text="Index Stocks">
                  <Dropdown.Menu>
                    <Dropdown.Item
                      value="Index and Sector Tracker"
                      name="Index and Sector Tracker"
                      onClick={this.handleSectorETFScreener}
                    >
                      Index and Sector Tracker
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="sp500_constituent"
                      onClick={this.handleCoatTailScreener}
                    >
                      S &amp; P 500 Index Stocks
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="dowjones_constituent"
                      onClick={this.handleCoatTailScreener}
                    >
                      Dow Jones Index Stocks
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="nasdaq_constituent"
                      onClick={this.handleCoatTailScreener}
                    >
                      NASDAQ Index Stocks
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="Russell Small Cap 2000 Stocks"
                      onClick={this.handleCoatTailScreener}
                    >
                      Russell Small Cap Index Stocks
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
              <Menu.Item fitted>
                <Dropdown item text="Tools">
                  <Dropdown.Menu>
                    <Dropdown.Item
                      value="performance"
                      onClick={this.handlePortfolioPerformance}
                    >
                      Portfolio Leaderboard
                    </Dropdown.Item>

                    <Dropdown.Item value="compare" onClick={this.compareStocks}>
                      Compare Stocks
                    </Dropdown.Item>
                    <Dropdown.Item value="ipo" onClick={this.setShowIPO}>
                      IPO Calendar
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="earningsCal"
                      onClick={this.handleEarningsCalendar}
                    >
                      Earnings Calendar
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="whatif"
                      onClick={this.handleWhatIfCalculator}
                    >
                      What If Calculator
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
              <Menu.Item fitted>
                <Dropdown item text="Help">
                  <Dropdown.Menu>
                    <Dropdown.Item value="siteHelp" onClick={this.setShowHelp}>
                      Site Help
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="releaseNotes"
                      onClick={this.setShowReleaseNotes}
                    >
                      What's New
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="submitFeature"
                      onClick={this.setShowSubmitFeature}
                    >
                      Submit Feature
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>

              <Menu.Item fitted position="right">
                {signoutButton}
              </Menu.Item>
            </Menu>
            {/* code for Company Tabs */}
            <div
              style={{
                minHeight: "200vh",
                display: showStck ? "block" : "none",
              }}
            >
              {mainContent}
            </div>
            {/* code for Aggrid screener */}
            <div
              style={{
                display: showScreener ? "block" : "none",
                marginTop: "-0.25rem",
                paddingTop: 0,
              }}
            >
              <div
                style={{
                  width: "auto",
                }}
              >
                {this.renderBackToLeaderboardBar()}
                {loading ? (
                  <LoadingSpinner />
                ) : !isFullScreener ? (
                  <ScreenerContainer
                    userEmail={this.props.userEmail}
                    portfolio={portfolio}
                    screenerTitle={portfolio?.name}
                    agGridFn={this.ag_grid_cell_click}
                    snapShotFn={this.loadSymbol}
                    portfolioImageUrl={portfolioImageUrl}
                  />
                ) : (
                  <StockScreener
                    userEmail={this.props.userEmail}
                    portfolio={portfolio}
                    portfolioImageUrl={portfolioImageUrl}
                  />
                )}
              </div>
            </div>
            {/* code for ETF screener */}
            <div
              style={{
                display: showETFScreener ? "block" : "none",
              }}
            >
              <div
                style={{
                  width: "auto",
                  marginTop: 0,
                }}
              >
                {this.renderBackToLeaderboardBar()}
                {loading ? (
                  <LoadingSpinner />
                ) : (
                  <ETFScreener
                    userEmail={this.props.userEmail}
                    portfolio={portfolio}
                    agGridFn={this.ag_grid_cell_click}
                  />
                )}
              </div>
            </div>
            {/* code for Performance Report */}
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1%",
                display: showPortfolioLeaderboard ? "block" : "none",
              }}
            >
              <PortfolioPerformance
                onOpenPortfolio={this.openPortfolioFromLeaderboard}
              />
            </div>
            {/*Code for Submit Feature */}
            <div
              style={{
                height: "84vh",
                display: showSubmitFeature ? "block" : "none",
              }}
            >
              <SubmitFeature
                name={this.props.name}
                email={this.props.userEmail}
                contactURL={Constants.FEATURE_REQUEST_URL}
                header="Please submit a feature request or feedback"
              />
            </div>
            {/*Code for user guide */}
            <div
              style={{
                maxWidth: "900px",
                margin: "1rem auto 0",
                padding: "0 1rem",
                display: showHelp ? "block" : "none",
              }}
            >
              <Help />
            </div>
            {/*Code for release notes */}
            <div
              style={{
                maxWidth: "900px",
                margin: "1rem auto",
                padding: "0 1rem",
                minHeight: "80vh",
                display: showReleaseNotes ? "block" : "none",
              }}
            >
              <ReleaseNotes />
            </div>
            {/* Favorites code */}
            <div
              style={{
                maxWidth: "960px",
                margin: "1rem auto",
                padding: "0 1rem",
                display: showFavorites ? "block" : "none",
              }}
            >
              <ScreenerCombinedView
                stockReports={portfolio ? portfolio.stockReports : null}
                displayAll={true}
              />
            </div>
            {/*Code for Index */}
            <div
              id="home-container"
              style={{
                justifyContent: "center",
                display: showIndex ? "block" : "none",
              }}
            >
              {!this.state.newUser ? (
                <HomeContainer
                  onClickIndexFunction={this.handleIndex}
                  onClickSymbolFunction={this.loadSymbol}
                />
              ) : (
                <WelcomePage userName={this.props.userName} />
              )}
            </div>
            {/*Code for IPO Calendar */}
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1%",
                display: showIPO ? "block" : "none",
              }}
            >
              <IPOCalendar />
            </div>
            {/*Code for Earnings Calendar */}
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1%",
                display: showEarningsCal ? "block" : "none",
              }}
            >
              <EarningsCalendar userEmail={this.props.userEmail} />
            </div>
            {/*Code for News*/}
            <div
              style={{
                minHeight: "600vh",
                height: "74vh",
                marginTop: "2%",
                display: showNews ? "block" : "none",
              }}
            >
              <MainNews />
            </div>
            {/*Code for Compare stocks */}
            <div
              style={{
                maxWidth: "960px",
                margin: "0.75rem auto 1rem",
                padding: "0 1rem",
                display: showCmprStcks ? "block" : "none",
              }}
            >
              <div
                style={{
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                <Typography
                  variant="h5"
                  gutterBottom
                  align="center"
                  sx={{
                    color: "primary.dark",
                    fontWeight: 600,
                    mb: 2,
                    mt: 0.5,
                    fontSize: { xs: "1.5rem", md: "1.75rem" },
                    letterSpacing: "-0.02em",
                  }}
                >
                  {" "}
                  Compare Stocks
                </Typography>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <MultiSearch
                  searchable={true}
                  showTags={true}
                  multiSelect={true}
                  width="100%"
                  onSelect={this.handleCmprStcks}
                  options={stocksDropDownValues}
                  searchPlaceholder={"Select Max 4 Symbols to compare"}
                  primaryColor={"#FFFFFF"}
                />
                <div>
                  <br />
                  <Button
                    size="large"
                    className="ui blue button"
                    onClick={this.compStcksSubmit}
                  >
                    Compare
                  </Button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "1%",
                  marginBottom: "1%",
                }}
              >
                {comparisionResult}
              </div>
            </div>
            {/*Code for My Portfolio */}
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1%",
                display: showMyPortfolio ? "block" : "none",
              }}
            >
              <PortfolioContainer
                userEmail={this.props.userEmail}
                userPortfolio={userPortfolio}
                portfolioExists={portfolioExists}
                showCreateUserPortfolioForm={showCreateUserPortfolioForm}
                newUserPortfolioNameInput={newUserPortfolioNameInput}
                onNewPortfolioNameInputChange={(e) =>
                  this.setState({ newUserPortfolioNameInput: e.target.value })
                }
                onCreateUserPortfolio={this.handleCreateUserPortfolio}
                isLoading={userPortfolioLoading}
                error={userPortfolioError}
                onSaveStock={this.handleSaveStockInUserPortfolio}
                onDeleteStock={this.handleDeleteStockInUserPortfolio}
                onRefreshPortfolio={this.fetchUserPortfolio}
                portfolioImageUrlFromHome={portfolioImageUrl}
                snapShotFnFromHome={this.loadSymbol}
              />
            </div>
            {/*Code for What If Calculator */}
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1%",
                display: this.state.showWhatIfCalculator ? "block" : "none",
              }}
            >
              <WhatIfCalculator />
            </div>
          </div>
        ) : (
          <>
            <div
              style={{
                width: "100%",
                top: 0,
                padding: "0.8rem",
                position: "relative",
                height: "auto",
                zIndex: 1,
                backgroundColor: "#102138",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                verticalAlign: "middle",
              }}
            >
              <Menu.Item style={{ padding: 0, marginRight: "0.25rem" }}>
                <Icon
                  name={menuIcon}
                  size="big"
                  onClick={this.handleSidebarToggle}
                  style={{
                    cursor: "pointer",
                    color: "white",
                  }}
                />
              </Menu.Item>

              <Menu.Item style={{ flexShrink: 0, padding: 0 }}>
                <div
                  style={{
                    width: 52,
                    height: 32,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    backgroundColor: "#102138",
                    borderRadius: "8px",
                border: "2px solid #d4a017"
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/simply-mobile.png`}
                    alt="SimplyStock"
                    onClick={this.reloadHomePage}
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      objectPosition: "left",
                    }}
                  />
                </div>
              </Menu.Item>

              <div style={{ flex: 1, minWidth: 0, margin: "0 0.5rem" }}>
                <SymbolSearch
                  onSymbolSelect={this.handleSymbolSelect}
                  onMenuSelect={this.handleMenuNavigation}
                  userEmail={this.props.userEmail}
                  dynamicItems={{
                    gurusList: this.state.gurusList || [],
                    countriesList: this.state.countriesList || [],
                  }}
                  initialValue={this.state.symbolValue}
                  fluid
                />
              </div>
              <Menu.Item fitted position="right">
                {signoutButton}
              </Menu.Item>
            </div>

            <Sidebar.Pushable
              style={{
                position: "relative",
                overflowX: "hidden",
              }}
            >
              <Sidebar
                as={Menu}
                animation="overlay"
                vertical
                visible={sidebarVisible}
                width="very thin"
                style={{
                  fontSize: "1em",
                  zIndex: 10,
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "min(270px, 85vw)",
                  overflowY: "auto",
                }}
              >
                <Menu.Item
                  active={activeItem === ""}
                  onClick={() => {
                    this.reloadHomePage();
                  }}
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Icon name="home" />
                  Home
                </Menu.Item>

                <Menu.Item
                  onClick={this.toggleMyLists}
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  My Lists <Icon name="dropdown" />
                </Menu.Item>
                {myListsOpen && (
                  <Menu
                    vertical
                    style={{
                      paddingLeft: "1em",
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                      width: "100%",
                    }}
                  >
                    <Menu.Item
                      value="watchList"
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                      content="Favorites"
                      icon="like"
                    />

                    <Menu.Item
                      value="myPortfolio"
                      onClick={(e) => {
                        this.handleMenuItemClick(e, { name: "myPortfolio" });
                        this.handleSidebarToggle();
                      }}
                      style={{
                        color: "black",
                      }}
                      content="My Portfolio"
                      icon="briefcase"
                    />
                  </Menu>
                )}

                <Menu.Item
                  onClick={this.toggleIndexStocks}
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Index Stocks <Icon name="dropdown" />
                </Menu.Item>
                {indexStocksOpen && (
                  <Menu
                    vertical
                    style={{
                      paddingLeft: "1em",
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                      width: "100%",
                    }}
                  >
                    <Menu.Item
                      value="Index and Sector Tracker"
                      name="Index and Sector Tracker"
                      onClick={this.handleSectorETFScreener}
                      style={{
                        color: "black",
                      }}
                      content="Index and Sector Tracker"
                    />
                    <Menu.Item
                      value="sp500_constituent"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                      content="S &amp; P 500 Index Stocks"
                    />

                    <Menu.Item
                      value="dowjones_constituent"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                      content="Dow Jones Index Stocks"
                    />

                    <Menu.Item
                      value="nasdaq_constituent"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                      content="NASDAQ Index Stocks"
                    />

                    <Menu.Item
                      value="Russell Small Cap 2000 Stocks"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                      content="Russell Small Cap Index Stocks"
                    />
                  </Menu>
                )}

                <Menu.Item
                  onClick={this.toggleInvestmentIdeas}
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Investment Ideas
                  <Icon name="dropdown" />
                </Menu.Item>
                {investmentIdeasOpen && (
                  <Menu
                    vertical
                    style={{
                      paddingLeft: "1em",
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                      width: "100%",
                    }}
                  >
                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.5em",
                      }}
                    >
                      SS Picks
                    </Menu.Item>
                    {this.state.gurusList &&
                      this.state.gurusList
                        .filter((item) => item.type === "SS List")
                        .map((item) => (
                          <Menu.Item
                            key={item.guru}
                            value={item.guru}
                            onClick={this.handleCoatTailScreener}
                            style={{
                              color: "black",
                              paddingLeft: "2em",
                            }}
                            content={item.guru}
                          />
                        ))}

                    <Menu.Item
                      value="Buy Rated Stocks dipped Today"
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      Buy Rated Stocks dipped Today
                    </Menu.Item>
                    <Menu.Item
                      value="Bestofall"
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      Best of All
                    </Menu.Item>
                    <Menu.Item
                      value="top50"
                      active={activeItem === "top50"}
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      Top 50 Value Stocks
                    </Menu.Item>
                    <Menu.Item
                      value="largeCap"
                      active={activeItem === "largeCap"}
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      Large Cap Growth
                    </Menu.Item>
                    <Menu.Item
                      value="smallMid"
                      active={activeItem === "smallMid"}
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      Great Small & Mid size Companies
                    </Menu.Item>
                    <Menu.Item
                      value="gems20"
                      active={activeItem === "gems20"}
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      Gems under $20
                    </Menu.Item>
                    <Menu.Item
                      value="dividend"
                      active={activeItem === "dividend"}
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      Good Dividend Stocks
                    </Menu.Item>
                    <Menu.Item
                      value="speculative"
                      active={activeItem === "speculative"}
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      Speculative Growth Stocks
                    </Menu.Item>
                    <Menu.Item
                      value="highPFStocks"
                      active={activeItem === "highPFStocks"}
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                    >
                      High Performing Stocks
                    </Menu.Item>
                    <Menu.Item
                      value="highProfitMargin"
                      active={activeItem === "highProfitMargin"}
                      onClick={this.handleIdeas}
                      style={{
                        color: "black",
                      }}
                      content="High Profit Margin Stocks"
                    />

                  </Menu>
                )}

                <Menu.Item
                  onClick={this.toggleSpecialScreeners}
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Screeners <Icon name="dropdown" />
                </Menu.Item>
                {specialScreenersOpen && (
                  <Menu
                    vertical
                    style={{
                      paddingLeft: "1em",
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                      width: "100%",
                    }}
                  >
                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.5em",
                      }}
                    >
                      Sectors
                    </Menu.Item>
                    <Menu.Item
                      value="Technology"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Technology"
                    />
                    <Menu.Item
                      value="Basic Materials"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Basic Materials"
                    />
                    <Menu.Item
                      value="Communication Services"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Communication Services"
                    />
                    <Menu.Item
                      value="Consumer Cyclical"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Consumer Cyclical"
                    />
                    <Menu.Item
                      value="Consumer Defensive"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Consumer Defensive"
                    />
                    <Menu.Item
                      value="Energy"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Energy"
                    />
                    <Menu.Item
                      value="Financial"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Financial"
                    />
                    <Menu.Item
                      value="Healthcare"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Healthcare"
                    />
                    <Menu.Item
                      value="Industrials"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Industrials"
                    />
                    <Menu.Item
                      value="Real Estate"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Real Estate"
                    />
                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.5em",
                      }}
                    >
                      Industries
                    </Menu.Item>
                    <Menu.Item
                      value="Residential Construction"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Residential Construction"
                    />
                    <Menu.Item
                      value="Restaurants"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Restaurants"
                    />
                    <Menu.Item
                      value="Lodging"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Lodging"
                    />
                    <Menu.Item
                      value="Airlines"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Airlines"
                    />
                    <Menu.Item
                      value="Resorts & Casinos"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Resorts & Casinos"
                    />
                    <Menu.Item
                      value="Travel & Leisure"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Travel & Leisure"
                    />
                    <Menu.Item
                      value="Travel Services"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Travel Services"
                    />
                    <Menu.Item
                      value="Grocery Stores"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Grocery Stores"
                    />
                    <Menu.Item
                      value="Discount Stores"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Discount Stores"
                    />
                    <Menu.Item
                      value="Semiconductor"
                      onClick={this.handleIndustryScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Semiconductor"
                    />
                    <Menu.Item
                      value="Pharma Companies"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Pharma Companies"
                    />
                    <Menu.Item
                      value="Shell Companies"
                      onClick={this.handleSectorScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Shell Companies"
                    />
                    <Menu.Item
                      value="Cannabis"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Cannabis"
                    />
                    <Menu.Item
                      value="Space Exploration"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Space Exploration"
                    />
                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.5em",
                      }}
                    >
                      Country
                    </Menu.Item>
                    {this.state.countriesList &&
                      this.state.countriesList.map((item) => (
                        <Menu.Item
                          key={item.code}
                          value={item.code}
                          onClick={this.handleCountrySelect}
                          style={{
                            color: "black",
                            paddingLeft: "2em",
                          }}
                          content={item.value}
                        />
                      ))}
                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.5em",
                      }}
                    >
                      Ev Related
                    </Menu.Item>
                    <Menu.Item
                      value="Electric Vehicles"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Electric Vehicles"
                    />
                    <Menu.Item
                      value="Battery-Charging"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Battery-Charging"
                    />
                    <Menu.Item
                      value="Natural Resources"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Natural Resources"
                    />
                    <Menu.Item
                      value="LIDAR"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="LIDAR"
                    />
                    <Menu.Item
                      value="EV Resources"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="EV Resources"
                    />
                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.5em",
                      }}
                    >
                      Clean Energy
                    </Menu.Item>
                    <Menu.Item
                      value="Solar"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Solar"
                    />
                    <Menu.Item
                      value="Fuel Cell"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Fuel Cell"
                    />
                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.5em",
                      }}
                    >
                      Speciality Tech
                    </Menu.Item>
                    <Menu.Item
                      value="Quantum Pure-play"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Quantum Pure-play"
                    />
                    <Menu.Item
                      value="Data Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Data Tech"
                    />
                    <Menu.Item
                      value="Internet Retail"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Internet Retail"
                    />
                    <Menu.Item
                      value="Health Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Health Tech"
                    />
                    <Menu.Item
                      value="Real Estate Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Real Estate Tech"
                    />
                    <Menu.Item
                      value="Fin Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Fin Tech"
                    />
                    <Menu.Item
                      value="Bio Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Bio Tech"
                    />
                    <Menu.Item
                      value="Cloud Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Cloud Tech"
                    />
                    <Menu.Item
                      value="5g Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="5g Tech"
                    />
                    <Menu.Item
                      value="AI Robotics Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="AI Robotics Tech"
                    />
                    <Menu.Item
                      value="Advertisement Tech"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                        paddingLeft: "2em",
                      }}
                      content="Advertisement Tech"
                    />
                    <Menu.Item
                      value="Led by Indian CEOs"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                      content="Led by Indian CEOs"
                    />
                    <Menu.Item
                      value="GLP-1 Drug Companies"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                      content="GLP-1 Drug Companies"
                    />
                    <Menu.Item
                      value="IPOs in last one year"
                      onClick={this.handleRecentIPOs}
                      style={{
                        color: "black",
                      }}
                      content="IPOs in last one year"
                    />
                  </Menu>
                )}

                <Menu.Item
                  onClick={this.toggleModelPortfolios}
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Model Portfolios <Icon name="dropdown" />
                </Menu.Item>
                {modelPortfoliosOpen && (
                  <Menu
                    vertical
                    style={{
                      paddingLeft: "1em",
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                      width: "100%",
                    }}
                  >
                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.25em",
                      }}
                    >
                      Gurus
                    </Menu.Item>
                    {this.state.gurusList &&
                      this.state.gurusList
                        .filter((item) => item.type === "Investment Guru")
                        .map((item) => (
                          <Menu.Item
                            key={item.guru}
                            value={item.guru}
                            onClick={this.handleCoatTailScreener}
                            style={{
                              color: "black",
                              paddingLeft: "2em",
                              fontFamily: "Verdana",
                            }}
                            content={item.guru}
                          />
                        ))}

                    <Menu.Item
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        paddingTop: "0.5em",
                        paddingBottom: "0.5em",
                      }}
                    >
                      Social Media
                    </Menu.Item>
                    {this.state.gurusList &&
                      this.state.gurusList
                        .filter((item) => item.type === "Watch List")
                        .map((item) => (
                          <Menu.Item
                            key={item.guru}
                            value={item.guru}
                            onClick={this.handleCoatTailScreener}
                            style={{
                              color: "black",
                              paddingLeft: "2em",
                              fontFamily: "Verdana",
                            }}
                            content={item.guru}
                          />
                        ))}

                    <Menu.Item
                      value="FAANG"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                      content="FAANG"
                    />

                    <Menu.Item
                      value="Magnificent 7"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                      content="Magnificent 7"
                    />

                    <Menu.Item
                      value="TAMANA"
                      onClick={this.handleCoatTailScreener}
                      style={{
                        color: "black",
                      }}
                    >
                      TAMANA
                    </Menu.Item>
                  </Menu>
                )}

                <Menu.Item
                  onClick={this.toggleTools}
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Tools
                  <Icon name="dropdown" />
                </Menu.Item>
                {toolsOpen && (
                  <Menu
                    vertical
                    style={{
                      paddingLeft: "1em",
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        maxWidth: "100%",
                      }}
                    >
                      <Menu.Item
                        value="performance"
                        active={activeItem === "performance"}
                        onClick={() => {
                          this.handlePortfolioPerformance();
                        }}
                        style={{
                          color: "black",
                        }}
                      >
                        Portfolio Leaderboard
                      </Menu.Item>

                      <Menu.Item
                        value="compare"
                        active={activeItem === "compare"}
                        onClick={() => {
                          this.compareStocks();
                        }}
                        style={{
                          color: "black",
                        }}
                      >
                        Compare Stocks
                      </Menu.Item>

                      <Menu.Item
                        value="ipo"
                        active={activeItem === "ipo"}
                        onClick={() => {
                          this.setShowIPO();
                        }}
                        style={{
                          color: "black",
                        }}
                      >
                        IPO Calendar
                      </Menu.Item>
                      <Menu.Item
                        value="earningsCal"
                        active={activeItem === "earningsCal"}
                        onClick={() => {
                          this.handleEarningsCalendar();
                        }}
                        style={{
                          color: "black",
                        }}
                      >
                        Earnings Calendar
                      </Menu.Item>
                      <Menu.Item
                        value="whatif"
                        active={activeItem === "whatif"}
                        onClick={() => {
                          this.handleWhatIfCalculator();
                        }}
                        style={{
                          color: "black",
                        }}
                      >
                        What If Calculator
                      </Menu.Item>
                    </div>
                  </Menu>
                )}

                <Menu.Item
                  onClick={this.toggleHelp}
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Help
                  <Icon name="dropdown" />
                </Menu.Item>
                {helpOpen && (
                  <Menu
                    vertical
                    style={{
                      paddingLeft: "1em",
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        maxWidth: "100%",
                      }}
                    >
                      <Menu.Item
                        value="siteHelp"
                        active={activeItem === "siteHelp"}
                        onClick={(e) => {
                          this.handleMenuItemClick(e, { name: "siteHelp" });
                        }}
                        style={{
                          color: "black",
                        }}
                      >
                        Site Help
                      </Menu.Item>

                      <Menu.Item
                        value="releaseNotes"
                        active={activeItem === "releaseNotes"}
                        onClick={(e) => {
                          this.handleMenuItemClick(e, { name: "releaseNotes" });
                        }}
                        style={{
                          color: "black",
                        }}
                      >
                        What's New
                      </Menu.Item>

                      <Menu.Item
                        value="submitFeature"
                        active={activeItem === "submitFeature"}
                        onClick={(e) => {
                          this.handleMenuItemClick(e, {
                            name: "submitFeature",
                          });
                        }}
                        style={{
                          color: "black",
                        }}
                      >
                        Submit Feature
                      </Menu.Item>
                    </div>
                  </Menu>
                )}
              </Sidebar>

              <Sidebar.Pusher
                style={{
                  backgroundcolor: "black",
                  marginLeft: sidebarVisible && !this.props.isMobile ? "200px" : "0",
                  transition: "margin-left 0.3s ease",
                }}
              >
                <div style={{ minHeight: "100vh", paddingBottom: this.props.isMobile ? "72px" : "0" }}>
                  {loading ? <LoadingSpinner /> : companyPage}
                  {showScreener && (
                    <>
                      {this.renderBackToLeaderboardBar()}
                      <ScreenerContainer
                        userEmail={this.props.userEmail}
                        portfolio={portfolio}
                        screenerTitle={portfolio?.name}
                        portfolioImageUrl={portfolioImageUrl}
                        agGridFn={this.loadSymbol}
                        snapShotFn={this.loadSymbol}
                      />
                    </>
                  )}
                  {showETFScreener && (
                    <>
                      {this.renderBackToLeaderboardBar()}
                      <ETFScreener
                        userEmail={this.props.userEmail}
                        portfolio={portfolio}
                        agGridFn={this.ag_grid_cell_click}
                      />
                    </>
                  )}
                  {showHelp && <Help />}
                  {showPortfolioLeaderboard && (
                    <PortfolioPerformance
                      onOpenPortfolio={this.openPortfolioFromLeaderboard}
                    />
                  )}
                  {showReleaseNotes && <ReleaseNotes />}
                  {showSubmitFeature && (
                    <SubmitFeature
                      name={this.props.name}
                      email={this.props.userEmail}
                      contactURL={Constants.FEATURE_REQUEST_URL}
                      header="Please submit a feature request or feedback"
                    />
                  )}
                  {showFavorites && (
                    <div
                      id="SnapShots"
                      style={{
                        maxWidth: "960px",
                        margin: "1rem auto",
                        padding: "0 1rem",
                      }}
                    >
                      <ScreenerCombinedView
                        stockReports={portfolio ? portfolio.stockReports : null}
                        displayAll={true}
                      />
                    </div>
                  )}
                  {showIndex && !this.props.newUser && (
                    <HomeContainer
                      onClickIndexFunction={this.handleIndex}
                      onClickSymbolFunction={this.loadSymbol}
                    />
                  )}
                  {showIndex && this.props.newUser && (
                    <WelcomePage userName={this.props.userName} />
                  )}
                  {showIPO && <IPOCalendar />}
                  {showNews && <MainNews isNewsOpen={true} />}

                  {showEarningsCal && (
                    <EarningsCalendar userEmail={this.props.userEmail} />
                  )}
                  {showMyPortfolio && (
                    <PortfolioContainer
                      userEmail={this.props.userEmail}
                      userPortfolio={userPortfolio}
                      portfolioExists={portfolioExists}
                      showCreateUserPortfolioForm={showCreateUserPortfolioForm}
                      newUserPortfolioNameInput={newUserPortfolioNameInput}
                      onNewPortfolioNameInputChange={(e) =>
                        this.setState({
                          newUserPortfolioNameInput: e.target.value,
                        })
                      }
                      onCreateUserPortfolio={this.handleCreateUserPortfolio}
                      isLoading={userPortfolioLoading}
                      error={userPortfolioError}
                      onSaveStock={this.handleSaveStockInUserPortfolio}
                      onDeleteStock={this.handleDeleteStockInUserPortfolio}
                      onRefreshPortfolio={this.fetchUserPortfolio}
                      portfolioImageUrlFromHome={portfolioImageUrl}
                      snapShotFnFromHome={this.loadSymbol}
                    />
                  )}
                  {showWhatIfCalculator && <WhatIfCalculator />}
                </div>
              </Sidebar.Pusher>
            </Sidebar.Pushable>
          </>
        )}
        {isMobile ? (
          <FixedBottomNavigation
            value={activeBottomTab}
            onChange={this.handleBottomNavigationChange}
            showLabels
          >
            <BottomNavigationAction
              label="Latest News"
              value="latestNews"
              icon={<NewspaperIcon />}
            />
            <BottomNavigationAction
              label="Home"
              value="home"
              icon={<HomeIcon />}
            />
            <BottomNavigationAction
              label="Favorites"
              value="watchList"
              icon={<ListIcon />}
            />
            <BottomNavigationAction
              label="Portfolio"
              value="myPortfolio"
              icon={<WorkIcon />}
              onClick={(e) => {
                this.handleMenuItemClick(e, { name: "myPortfolio" });
              }}
            />
          </FixedBottomNavigation>
        ) : null}
      </>
    );
  }
}

export default withMobile(Home);
